import { Duration } from 'luxon';

export const formatDuration = (value?: string): string => {
  if (!value) {
    return '-';
  }
  
  const duration: Duration = Duration.fromISO(value);
  
  if (!duration.isValid) {
    return value;
  }
  
  const shiftedDuration: Duration = duration.shiftTo('hours', 'minutes', 'seconds').normalize();
  
  const hours: number = Math.trunc(shiftedDuration.hours);
  const minutes: number = Math.trunc(shiftedDuration.minutes);
  const seconds: number = Math.round(shiftedDuration.seconds);
  
  if (hours > 0) {
    return `${hours} h ${minutes} min`;
  }
  
  if (minutes > 0) {
    return `${minutes} min`;
  }

  return `${seconds} sec`;
}

export function formatHours(totalHours: number): string {
  const totalMinutes: number = Math.round(totalHours * 60);
  const hours: number = Math.floor(totalMinutes / 60);
  const minutes: number = totalMinutes % 60;
  return `${hours}h ${minutes.toString().padStart(2, '0')}min`;
}